import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
import * as utils from 'core/utils';
import * as i18next from 'i18next';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export default class PartnerComponent extends Vue {
    @Prop()
    searchId?: string;

    @Prop()
    flightId?: string;

    @Prop()
    partnerName?: string;

    view: 'loading' | 'error' = 'loading';
    errorHtml = i18next.t('error_something_wrong');

    get redirectLabel() {
        return this.partnerName
            ? i18next.t('label_partner_redirect_to') + ` ${this.partnerName}`
            : i18next.t('label_partner_redirect');
    }

    mounted() {
        this.processExternalLinkRequest();
    }

    processExternalLinkRequest() {
        if (this.flightId && this.searchId) {
            const request: api.ExternalLinkRequest = {
                flightId: this.flightId,
                searchId: this.searchId
            };

            new api.FlightService().externalLink(request).then(
                (result: api.ExternalLinkResponse) => {
                    if (result?.method.toLocaleLowerCase() == 'get'
                        && result.url) {
                        window.location.replace(result.url);
                    }
                    if (result?.method.toLocaleLowerCase() == 'post'
                        && result.url
                        && result.pixelUrl
                        && result.params) {
                        let pixel = window.document.createElement('img');

                        pixel.width = 0;
                        pixel.height = 0;
                        pixel.src = result.pixelUrl;
                        (this.$refs.component as HTMLDivElement).appendChild(pixel);

                        let params: api.RequestParam[] = [];

                        for (let key in result.params) {
                            params.push({
                                paramName: key,
                                paramValue: result.params[key]
                            });
                        }
                        window.setTimeout(() => {
                            utils.Http.redirect({
                                method: result.method,
                                url: result.url,
                                requestParameters: params
                            });
                        }, 1000);
                    }
                },
                (error) => {
                    if (error.response) {
                        console.log('XHR failed', error.response.status, error.response.data);
                    } else {
                        console.log('XHR error', error.message);
                    }
                    this.view = 'error';
                }
            );
        } else {
            window.location.href = '/';
        }
    }
}